// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M1 3H23V21H13V20.0039C13 13.9288 8.07513 9.00391 2 9.00391H1.00391L1 9V3Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M1 11H2C6.97056 11 11 15.0294 11 20V21H9V20C9 16.134 5.86599 13 2 13H1V11Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M1 15H2C4.76142 15 7 17.2386 7 20V21H5V20C5 18.3431 3.65685 17 2 17H1V15Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M3.00391 19H1V21.0039H3.00391V19Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-cast-filled')
export default class CastFilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'cast-filled',
    }
  }
}
